import { Box, Typography, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const SummaryBox = styled(Box)(({ theme }) => ({
  marginTop: '0.75rem',
  padding: '0.625rem 0.75rem',
  borderRadius: '0.625rem',
  border: `0.0625rem solid ${alpha(theme.palette.error.main, 0.24)}`,
  backgroundColor: alpha(theme.palette.error.main, 0.06),
}));

export const ItemList = styled('ul')({
  margin: 0,
  padding: '0 0 0 1.125rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.125rem',
});

export const Item = styled('li')(({ theme }) => ({
  color: theme.palette.grey[900],
}));

export const ItemText = styled('span')(({ theme }) => ({
  fontSize: '0.84375rem',
  lineHeight: 1.45,
  color: theme.palette.grey[900],
  wordBreak: 'break-all',
  fontFamily: 'Neue Frutiger World',
}));

export const ItemLink = styled('a')(({ theme }) => ({
  fontSize: '0.84375rem',
  lineHeight: 1.45,
  color: theme.palette.primary.main,
  textDecoration: 'underline',
  wordBreak: 'break-all',
  fontFamily: 'Neue Frutiger World',
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));

export const MoreText = styled(Typography)(({ theme }) => ({
  marginTop: '0.25rem',
  fontSize: '0.78125rem',
  color: theme.palette.grey[700],
  fontFamily: 'Neue Frutiger World',
}));
